import React, { useState } from "react";
import { colors } from "theme/Theme";
import { Chevron } from "features/breadcrumb/Breadcrumb";
import {
  hideRootModal,
  showRootModal,
} from "features/rootModal/rootModalSlice";
import { BsFilterRight } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { Wrapper } from "./BottomBarItem";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { PageWithFilterType } from "features/Filters/types";
import {
  fetchFilteredAccessories,
  selectAccessories,
} from "features/accessories/accessoriesSlice";
import {
  fetchFilteredProducts,
  selectFilteredProducts,
} from "features/category/categorySlice";

const FilterButton: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpened, setIsOpened] = useState(false);

  const showFiltersModal = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isOpened) {
      if (location.pathname.includes(PageWithFilterType.accessories)) {
        dispatch(
          showRootModal({
            modalType: "FILTERS",
            modalProps: {
              filteredProductsSelector: selectAccessories,
              fetchFilteredProductsFN: fetchFilteredAccessories,
              pageType: PageWithFilterType.accessories,
              setIsOpened,
            },
          })
        );
      } else {
        !location.pathname.includes(PageWithFilterType.category) &&
          navigate(`/${PageWithFilterType.category}`);
        dispatch(
          showRootModal({
            modalType: "FILTERS",
            modalProps: {
              filteredProductsSelector: selectFilteredProducts,
              fetchFilteredProductsFN: fetchFilteredProducts,
              pageType: PageWithFilterType.category,
              setIsOpened,
            },
          })
        );
      }
    } else {
      dispatch(hideRootModal());
    }
    setIsOpened(!isOpened);
  };

  return (
    <Wrapper onClick={showFiltersModal}>
      <Chevron backgroundColor={`${colors.lighter_blue}`}>
        <BsFilterRight style={{ width: 32, height: 32, color: "white" }} />
      </Chevron>
    </Wrapper>
  );
};

export default FilterButton;
